import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

export default function LoginPage() {
  const { t, i18n } = useTranslation();
  const { signIn } = useAuth();
  const lang = (i18n.language || 'fr').startsWith('en') ? 'en' : 'fr';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { error: err } = await signIn(email, password);
      if (err) setError(t('auth.loginError'));
    } catch {
      setError(t('auth.loginError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        gap: 16,
        padding: 16,
        boxSizing: 'border-box',
        background: 'var(--color-bg, #f5f5f5)',
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          background: '#fff',
          padding: 32,
          borderRadius: 'var(--radius, 8px)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          width: '100%',
          maxWidth: 400,
        }}
      >
        <h2 style={{ marginBottom: 24, textAlign: 'center' }}>
          {t('auth.loginTitle')}
        </h2>

        {error && (
          <div style={{ color: 'red', marginBottom: 16, textAlign: 'center' }}>
            {error}
          </div>
        )}

        <div style={{ marginBottom: 16 }}>
          <label htmlFor="login-email" style={{ display: 'block', marginBottom: 4 }}>
            {t('auth.email')}
          </label>
          <input
            id="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            style={{ width: '100%', padding: 8, boxSizing: 'border-box' }}
          />
        </div>

        <div style={{ marginBottom: 24 }}>
          <label htmlFor="login-password" style={{ display: 'block', marginBottom: 4 }}>
            {t('auth.password')}
          </label>
          <input
            id="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            style={{ width: '100%', padding: 8, boxSizing: 'border-box' }}
          />
        </div>

        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading}
          style={{ width: '100%' }}
        >
          {loading ? t('auth.loggingIn') : t('auth.loginButton')}
        </button>
      </form>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          fontSize: 13,
          color: 'var(--color-text-light, #64748b)',
        }}
      >
        <Link to="/privacy" style={{ color: 'inherit' }}>{t('legal.privacyLink')}</Link>
        <span>·</span>
        <Link to="/terms" style={{ color: 'inherit' }}>{t('legal.termsLink')}</Link>
        <span>·</span>
        <button
          type="button"
          className="lang-switch"
          onClick={() => i18n.changeLanguage(lang === 'fr' ? 'en' : 'fr')}
        >
          {lang === 'fr' ? 'EN' : 'FR'}
        </button>
      </div>
    </div>
  );
}
